import React, { useState } from 'react'
import { PLACEMENT, StatefulPopover, TRIGGER_TYPE } from "baseui/popover";
import { Block } from "baseui/block";
import { colors, fonts, glyphs } from '../../Styles';
import { CalendarEventNote } from '../../Assets/TestData/animalData';

interface EventNotePopover_Props {
  eventName: string
  eventNote: CalendarEventNote[]
  glyphColor?: colors
}
/**
 * EventNotePopover
 * @param selectedAnimal
 * @returns
 */
export default function EventNotePopover({eventName, eventNote, glyphColor}:EventNotePopover_Props) {
  const [isOpen, setIsOpen] = useState(false)

  // Date formatting function
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  
  return (
    <StatefulPopover
      showArrow={true}
      onClose={() => setIsOpen(false)}
      placement={PLACEMENT.auto}
      triggerType={TRIGGER_TYPE.hover}
      initialState={{ isOpen: isOpen }}
      content={() => (
        <Block>
          <div style={{ padding: "10px 10px 5px 10px", textAlign: "center", ...fonts.header, ...fonts.fontSize3, color: colors.greyLightPrimary}}>
            {eventName}
          </div>
          <div style={{backgroundColor: colors.greyDarkPrimary, padding: "10px 20px", margin: "2px", borderRadius: "0px 0px 8px 8px",display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
          }}>
            {eventNote.map((note, noteIndex) => (    
              <div key={noteIndex}>              
                {Object.entries(note).map(([key, value]) => (
                <div key={key} style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", width: "100%" }}>
                  <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightPrimary, textAlign: "right" }}>{key}:</p>
                  <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightPrimary, textAlign: "left" }}>{value instanceof Date ? formatDate(value) : value}</p>
                </div>
                ))}
              </div>
            ))}
          </div>
        </Block>
      )}
      overrides={{
        Arrow: { style: () => Object.assign({}, {
          backgroundColor: colors.blueDarkPrimary,
          width: "30px",
          height: "30px",
        } as React.CSSProperties )},
        Body: { style: () => Object.assign({}, {
          backgroundColor: colors.blueDarkPrimary,
          borderRadius: "10px",
          width: "fit-content",
          height: "fit-content",
          top: "-2px"
        } as React.CSSProperties )},
        Inner: { style: () => Object.assign({}, {
          backgroundColor: colors.blueDarkPrimary,
          borderRadius: "10px",
        } as React.CSSProperties )},
      }}
    >
      {/* Popover Activator (to show in StatusBar) */}
      <div 
        onClick={() => setIsOpen(true)}
        style={{
          width: "fit-content",
          height: "fit-content",
          margin: "-5px 0px",      
          cursor: "pointer"
        }}
      >
        <glyphs.Note fillColor={glyphColor}/>
      </div>
    </StatefulPopover>
  );
}